import styled from 'styled-components';

export const Pill = styled.div<{
  $unpopulated?: boolean;
  $bordered: boolean;
  $radius: number;
  $padding: string;
  $gap: number;
}>`
  display: inline-flex;
  align-items: center;
  grid-gap: ${({ $gap }) => $gap}px;
  border-radius: ${({ $radius }) => $radius}px;
  padding: ${({ $padding }) => $padding};
  background-color: ${({ theme, $unpopulated }) =>
    $unpopulated ? theme.colors.dropZoneErrBg : theme.colors.aliceBlue};
  /* Unpopulated always draws the red border (the alert needs it); the populated
     border is opt-out (none, not a transparent 1px) so the AI chips stay the same
     height as their borderless constant-pill neighbours in the same formula row. */
  border: ${({ theme, $unpopulated, $bordered }) =>
    $unpopulated
      ? `1px solid ${theme.colors.dropZoneErrBorder}`
      : $bordered
        ? `1px solid ${theme.colors.stroke}`
        : 'none'};

  .vp-icon {
    display: inline-flex;
    align-items: center;
  }
`;
